import React from "react";
import { connect } from "react-redux";
import * as resActions from "../../modules/resources";
import PropTypes from "prop-types";
import withFormState from "Components/withFormState";
import { displayFormattedDate } from "Utils/dateFormats";
import Loader from "Components/loader/Loader";
import Tabs from "Components/tabs/Tabs";
import Settings from "./settings/Settings";
import Details from "./settings/Details";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";

import _ from "lodash";
import QboxmailApi from "../../qboxmailApi.js";

import ButtonBack from "Components/buttonBack/ButtonBack";
import DetailStatus from "Components/detailStatus/DetailStatus";
import DetailInfo from "Components/detailInfo/DetailInfo";

import cx from "classnames";
import s from "./showDelegates.scss";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

const formInitialState = {
  expiration: undefined,
  no_expiration: true,
  always: true,
  visualization_start: undefined,
  visualization_end: undefined,
};

class DelegateShowScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = { domainsEmails: [], showInfo: this.props.isMediaMobile ? false : true };
    this.goBack = this.goBack.bind(this);
    this.resetAndGoBack = this.resetAndGoBack.bind(this);
    this.toggleInfo = this.toggleInfo.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.getDelegate();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const delegateLoaded = this.props.isDelegateLoading && !nextProps.isDelegateLoading;
    if (delegateLoaded) {
      const { delegate } = nextProps;
      this.props.setInitialValues({
        expiration: delegate.expiration && new Date(delegate.expiration),
        no_expiration: !delegate.expiration,
        always: !delegate.visualization_start && !delegate.visualization_end,
        visualization_start: delegate.visualization_start && new Date(delegate.visualization_start),
        visualization_end: delegate.visualization_end && new Date(delegate.visualization_end),
      });

      let client = new QboxmailApi({ useCookie: true });
      client
        .getArchiveEmailsForDomains(_.uniq(delegate.email_accounts.map((em) => em.domain_code)))
        .then((resp) => {
          this.setState({ domainsEmails: resp.resources });
        });
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMediaMobile !== this.props.isMediaMobile) {
      this.setState({
        showInfo: this.props.isMediaMobile ? false : true,
      });
    }
  }

  returnToList() {
    this.props.history.push(this.props.backlinkRoute);
  }

  resetAndGoBack() {
    this.props.resetForm();
    this.returnToList();
  }

  goBack() {
    this.props.history.push("/delegates");
  }

  toggleInfo() {
    this.setState({ showInfo: !this.state.showInfo });
  }

  render() {
    const { isDelegateLoading, delegate } = this.props;

    const { domainsEmails, showInfo } = this.state;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    const loggedUser = this.context.getLoggedUser();
    let canManageDelegate = true;
    if (loggedUser.type === "TeamMember") {
      if (!loggedUser.permissions.includes("manage_vault_delegate")) {
        canManageDelegate = false;
      }
    }

    if (isDelegateLoading || domainsEmails.length === 0) {
      return <Loader />;
    }

    let tabs = {
      [t("tab.registry")]: <Details {...this.props} domainsEmails={domainsEmails} />,
    };

    if (canManageDelegate) {
      tabs[t("tab.settings")] = <Settings {...this.props} domainsEmails={domainsEmails} />;
    }

    return (
      <div className={s.showDelegate}>
        <div className={s.navigation}>
          <ButtonBack onClick={this.goBack} />
          <div className={s.viewSectionLabel}>{t("section.view.delegate")}</div>
        </div>

        <div className={s.header}>
          <div className={s.wrapTitle}>
            <div className="sectionTitle">{`${delegate.firstname} ${delegate.lastname}`}</div>
            {isMediaMobile() && (
              <div className={cx(s.showInfo, "internalLink")} onClick={this.toggleInfo}>
                {showInfo ? t("button.details.hide") : t("button.details.show")}
              </div>
            )}
          </div>

          {showInfo && (
            <div className={s.subtitle}>
              <DetailStatus status={delegate.status} />
              <div className="sectionDesc">{delegate.email_address}</div>
            </div>
          )}

          {showInfo && (
            <div className={s.info}>
              <DetailInfo label={t("detailInfo.label.code")} info={delegate.code} inLine />

              <DetailInfo
                label={t("detailInfo.label.company")}
                info={delegate.company ? delegate.company : "–"}
                inLine
              />

              <DetailInfo
                label={t("detailInfo.label.created")}
                info={displayFormattedDate(delegate.created_at)}
                inLine
              />

              {delegate.manager_fullname && (
                <DetailInfo
                  label={t("detailInfo.label.manager")}
                  info={delegate.manager_fullname}
                  inLine
                />
              )}

              <DetailInfo
                label={t("detailInfo.label.expiration")}
                info={
                  delegate.expiration
                    ? new Date(delegate.expiration).toLocaleDateString()
                    : t("detailInfo.data.noExpiration")
                }
                inLine
              />
            </div>
          )}
        </div>

        <Tabs className={s.settings} {...this.props} tabs={tabs} />
      </div>
    );
  }
}

//DelegateShowScreen.propTypes = propTypes;
DelegateShowScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  delegate: resActions.getData("delegate.data.0", state),
  isDelegateLoading: resActions.isResourceLoading("delegate", state),
});

const mapDispatchToProps = (dispatch, props) => {
  const delegateCode = props.match.params.delegateCode;

  return {
    refreshDelegate: () =>
      dispatch(resActions.callApi("refreshDelegate", "delegate", delegateCode)),
    getDelegate: () => dispatch(resActions.callApi("getDelegate", "delegate", delegateCode)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormState(DelegateShowScreen, formInitialState));
